import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LoadArbitraryChartData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LoadArbitraryChartDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LoadArbitraryChartDataStore",
			variables: true,
		})
	}
}

export async function load_LoadArbitraryChartData(params) {
  await initClient()

	const store = new LoadArbitraryChartDataStore()

	await store.fetch(params)

	return {
		LoadArbitraryChartData: store,
	}
}
